import React from "react";
import { Box, Grid } from "@material-ui/core";
import CustomTextField from "../../shared/CustomTextField";
import { finalizeWebUserFields } from "../Registration/webUserFormLabel";
import getInputError from "../../messages/inputsValidation";
import Hidden from "@material-ui/core/Hidden";

interface IProps {
  accountData: any;
  register: any;
  errors: any;
  isInvoice: boolean;
  isInvoiceCompany: boolean;
}
const getShrink = (value: string) => ({ shrink: Boolean(value) });

const AccountForm: React.FC<IProps> = ({ accountData, register, errors, isInvoice, isInvoiceCompany }: IProps) => {
  return (
    <Box my={3} style={{ width: "90%", padding: "2%" }}>
      <form>
        <Grid container spacing={3}>
          {finalizeWebUserFields(isInvoice, isInvoiceCompany).map(
            ({ name, label, validator }, index) =>
              name && (
                <React.Fragment key={index}>
                  <Hidden mdDown>
                    <Grid item xs={3}>
                      <CustomTextField
                        InputLabelProps={getShrink(accountData[name])}
                        error={Boolean(errors.name)}
                        helperText={errors.name ? getInputError(errors, "name") : " "}
                        label={`${label}(*)`}
                        name={name}
                        inputRef={validator ? register(validator) : register}
                        fullWidth
                      />
                    </Grid>
                  </Hidden>
                  <Hidden lgUp>
                    <Grid item xs={6}>
                      <CustomTextField
                        InputLabelProps={getShrink(accountData[name])}
                        error={Boolean(errors.name)}
                        helperText={errors.name ? getInputError(errors, "name") : " "}
                        label={`${label}(*)`}
                        name={name}
                        inputRef={validator ? register(validator) : register}
                        fullWidth
                      />
                    </Grid>
                  </Hidden>
                </React.Fragment>
              )
          )}
        </Grid>
      </form>
    </Box>
  );
};

export default AccountForm;
